module.exports = __webpack_public_path__ + "static/media/commodity-receipt.f33f39d2.jpg";